import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ChartType, GoogleChartComponent } from 'angular-google-charts';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs-compat';
import { environment } from 'src/environments/environment';
import { MessagesDTO } from '../common/notification/MessagesDTO';
import { CommonService } from '../service/Security/common.service';
import { Lines } from './Lines';
import { HttpErrorResponse } from '@angular/common/http';
import { APIFactoryEndPoints } from '../common/apifactory-end-points';
import { Constant } from '../common/constant';
import { ErrorLog } from '../model/Common/error-log';
import moment from 'moment';
import { MainContainerService } from '../service/main-container.service';
import { PushUserIdAndLocToAndroidApp } from 'src/myfunc';
import { DashboardDto } from '../model/dashboard-dto';
import { Location } from 'src/app/model/location';
import { ChartThemeService } from '../service/chart-theme.service';
import { ThemeService } from '../service/theme.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('chart') chart: GoogleChartComponent;
  orderedQty: number
  productionQty: number
  dispathcQty: number
  receiveQty: number
  onDate: String
  barChartType: ChartType
  width: number = 500
  fullwidth: number = 0;
  //Height fixed
  fullHeight: number = 150
  legendTypeFull: object = {
    legend: { position: 'none' }, chartArea: { width: this.fullwidth, height: '80%', left: 40, top: 20, bottom: 60, right: 20 },
    // hAxis: {
    //   title: 'Date'
    // },
    // vAxis: {
    //   title: 'Sale'
    // },
  };
  // orderChartData = {
  //   type: ChartType.LineChart,
  //   data: [],
  //   columnNames: ["Date", "Ordered", "Received", "Payment"],
  //   options: {
  //     legend: { position: 'bottom' },
  //     // backgroundColor: '#dae3f3',
  //     hAxis: {
  //       title: 'Date'
  //     },
  //     // vAxis: {
  //     //   title: 'Sale'
  //     // },
  //   },
  // };

  orderChartData: any;
  makeToOrderDataToday: any;
  makeToOrderDataMonth: any;
  saleDataMonthBills: any;
  saleDataMonthAmount: any;


  // makeToOrderDataToday = {
  //   type: ChartType.BarChart,
  //   data: [],
  //   columnNames: ["MTO", "Qty"],
  //   options: {
  //     vAxis: {
  //       minValue: 0,
  //       title: 'Today'
  //     },
  //     hAxis: {
  //       minValue: 0
  //     },
  //     legend: { position: 'none' },
  //     // backgroundColor: '#adb9ca'
  //     chartArea: {
  //       top: 10,  // Reduce top padding
  //       left: 50,
  //       right: 20,
  //       // width: '90%',
  //       height: '80%',
  //       width: this.fullwidth,
  //     }
  //   }
  // };

  // makeToOrderDataMonth = {
  //   type: ChartType.BarChart,
  //   data: [],
  //   columnNames: ["MTO", "Qty"],
  //   options: {
  //     legend: { position: 'none' },
  //     // backgroundColor: '#dae3f3'
  //     vAxis: {
  //       title: 'Current Month'
  //     },
  //     chartArea: {
  //       top: 5,  // Reduce top padding
  //       left: 50,
  //       right: 20,
  //       // width: '90%',
  //       height: '80%',
  //       width: this.fullwidth,
  //     }
  //   }
  // };

  // saleDataMonthBills = {
  //   type: ChartType.ColumnChart,
  //   data: [],
  //   columnNames: ["On Date", "Bills"],
  //   options: {
  //     legend: { position: 'none' },
  //     vAxis: {
  //       title: 'Current Month Bills'
  //     },
  //     // backgroundColor: '#dae3f3'
  //     chartArea: {
  //       top: 20,  // Reduce top padding
  //       left: 20,
  //       right: 20,
  //       // width: '90%',
  //       height: '80%',
  //       width: this.fullwidth,
  //     }
  //   }

  // };

  // saleDataMonthAmount = {
  //   type: ChartType.LineChart,
  //   data: [],
  //   columnNames: ["On Date", "Amount"],
  //   options: {
  //     legend: { position: 'none' },
  //     vAxis: {
  //       title: 'Current Month Amount'
  //     },
  //     // backgroundColor: '#dae3f3'
  //     chartArea: {
  //       top: 20,  // Reduce top padding
  //       left: 20,
  //       right: 20,
  //       // width: '90%',
  //       height: '80%',
  //       width: this.fullwidth,
  //     }
  //   }

  // };

  // saleDataToday = {
  //   type: ChartType.ColumnChart,
  //   data: [],
  //   columnNames: ["Qty", "Amount", { type: 'string', role: 'tooltip', p: { html: true } }],
  //   options: {
  //     legend: { position: 'none' },
  //     // backgroundColor: '#adb9ca'
  //     vAxis: {
  //       title: 'Today'
  //     },
  //     chartArea: {
  //       top: 20,  // Reduce top padding
  //       left: 20,
  //       right: 20,
  //       // width: '90%',
  //       height: '80%',
  //       width: this.fullwidth,
  //     },
  //     tooltip: {
  //       isHtml: true,
  //       trigger: 'selection'
  //     }
  //   }

  // };

  notificationSubscription: Subscription;
  activitySubscription: Subscription;
  messagesDTO: MessagesDTO[];
  ROLStatus: number = 0;
  activityDTO: any;
  orderStatus: any;
  mtoStatus: any;
  saleStatusDto: any;
  availableCredit: number = 0
  lastOrderedValue: number = 0
  lastMonthOrderedValue: number = 0
  lastPreviousMonthOrderedValue: number = 0
  lastReceivedValue: number = 0
  lastMonthReceivedValue: number = 0
  lastPreviousMonthReceivedValue: number = 0
  lastReturnedValue: number = 0
  lastMonthReturnedValue: number = 0
  lastPreviousMonthReturnedValue: number = 0
  lastBilledValue: number = 0
  lastMonthBilledValue: number = 0
  lastPreviousMonthBilledValue: number = 0
  lastPaymentValue: number = 0
  lastMonthPaymentValue: number = 0
  lastPreviousMonthPaymentValue: number = 0
  showOrderGraph: boolean = false;
  showSaleGraph: boolean = false;
  showMTOGraph: boolean = false;
  MTOStatus: number = 0;
  MTOInProcessStatus: number = 0;
  MTOProductionStatus: number = 0;
  PerformanceDto: any;
  maintenanceOnToday: number = 0;
  maintenanceinNext5Days: number = 0;
  AssetMaintenanceIssuesStatus: number = 0;
  InsuranceStatusperiod60: number = 0;
  InsuranceStatusperiod30: number = 0;
  InsuranceStatusperiod15: number = 0;
  InsuranceStatusperiod0: number = 0;
  InsuranceStatusperiodlapses: number = 0;
  todayOrderValue: number = 0;
  todayReceivedValue: number = 0;
  todayReturnedValue: number = 0;
  todayBilledValue: number = 0;
  todayPaymentValue: number = 0;
  showDashboard: boolean = false;
  errorLog: ErrorLog = new ErrorLog();
  loginLocation: Location;
  couponList: any[] = [];
  spinWinList: any[] = [];
  displayCoupons: boolean = false;
  displaySpinWin: boolean = false;

  private intervalSubscription: Subscription;
  private getCouponHistorySubscription: Subscription;
  private getSpinWinHistorySubscription: Subscription;
  private insertErrorLogSubscription: Subscription;
  private themeSub!: Subscription;
  private themeSubMTO!: Subscription;
  private themeSubSale!: Subscription;

  height: number;

  constructor(
    public persistenceService: LocalStorageService,
    private commonService: CommonService,
    public datepipe: DatePipe,
    private apiFactory: APIFactoryEndPoints,
    public containerService: MainContainerService,
    public constant: Constant,
    private themeService: ThemeService,
    private chartThemeService: ChartThemeService,
  ) {
    this.loginLocation = JSON.parse(this.persistenceService.get('userDetail')).location;
  }

  relationships = "20,20 40,25 60,40 80,120 120,140 200,180";
  lines: Lines[];

  ngOnInit() {
    if (this.persistenceService.get('userDetail') != undefined) {
      this.showDashboard = true
      if (this.persistenceService.get('userDetail') != "null")
        this.getTriggers();
    }
    if (this.persistenceService.get("OS") == "Android")
      PushUserIdAndLocToAndroidApp(this.persistenceService.get("userId"), this.persistenceService.get("locRefNo"))

    this.fullwidth = window.innerWidth - 80
    this.getCouponDetails();
  }

  ngOnDestroy() {
    if (this.getCouponHistorySubscription !== undefined)
      this.getCouponHistorySubscription.unsubscribe();

    if (this.getSpinWinHistorySubscription !== undefined)
      this.getSpinWinHistorySubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getCouponDetails() {
    this.getCouponHistorySubscription = this.containerService.getCouponHistoryByLoginLocation(this.apiFactory.getCouponHistoryByLoginAndParentLocationCode, this.loginLocation.refNo).subscribe((data) => {
      if (data == null)
        return;
      if (data.length >= 1) {
        this.couponList = data;
        this.displayCoupons = true;
      }
      this.getSpinWinDetails();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getCouponDetails", error);
      });
  }

  getSpinWinDetails() {
    this.getSpinWinHistorySubscription = this.containerService.getCouponHistoryByLoginLocation(this.apiFactory.getSpinWinHistoryByLoginLocationCode, this.loginLocation.refNo).subscribe((data) => {
      if (data == null)
        return;
      if (data.length >= 1) {
        this.spinWinList = data;
        this.displaySpinWin = true;
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getSpinWinDetails", error);
      });
  }

  currentdate: Date = new Date();
  getDaysSince(date: any): number {
    const from = new Date(date);
    const to = new Date(this.currentdate);

    // Clear time portion for accurate difference
    from.setHours(0, 0, 0, 0);
    to.setHours(0, 0, 0, 0);

    const diffInMs = to.getTime() - from.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays + 1;
  }

  runAllTriggers() {
    const source = interval(30 * 1000);
    this.intervalSubscription = source.subscribe(val => {
      this.maintenanceOnToday = 0
      this.InsuranceStatusperiod60 = 0
      this.maintenanceinNext5Days = 0
      this.InsuranceStatusperiod60 = 0
      this.InsuranceStatusperiod15 = 0
      this.InsuranceStatusperiod0 = 0
      this.InsuranceStatusperiodlapses = 0

      this.MTOInProcessStatus = 0
      this.MTOProductionStatus = 0
      if (this.persistenceService.get('userDetail') != null)
        this.getTriggers();

    });
  }
  getTriggers() {
    this.notificationSubscription = this.commonService.getROLStatus(JSON.parse(this.persistenceService.get('userDetail'))?.location?.refNo).subscribe((data: any) => {
      if (data != null)
        this.ROLStatus = data?.length;
      else
        return;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTriggers", error);
      });
    if (JSON.parse(this.persistenceService.get('userDetail'))?.parentLocRefNo == JSON.parse(this.persistenceService.get('userDetail'))?.location?.refNo) {
      this.notificationSubscription = this.commonService.getMTOStatus(JSON.parse(this.persistenceService.get('userDetail'))?.parentLocRefNo).subscribe((data: any) => {
        if (data == null)
          return;
        for (let i = 0; i < data?.length; i++) {
          if (data[i].process == "Process")
            this.MTOInProcessStatus++;
          if (data[i].process == "Production")
            this.MTOProductionStatus++;;
        }
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("getTriggers", error);
        });
    }
    this.notificationSubscription = this.commonService.getPerformanceUpdate(JSON.parse(this.persistenceService.get('userDetail'))?.location?.refNo).subscribe((data: any) => {
      if (data == null)
        return;
      this.PerformanceDto = data;
      for (let i = 0; i < this.PerformanceDto?.length; i++) {
        if (this.PerformanceDto[i].createdDate == "NA")
          if (this.PerformanceDto[i].modifiedDate == "NA") {
            var purDate = new Date(this.PerformanceDto[i].purchaseDate);
            var curDate = new Date();
            var time = curDate.getTime() - purDate.getTime()
            var noOfDaysSincePurchased = Number((time / (1000 * 3600 * 24)).toFixed(0));
            var noOfTimesMaintenanceScheduled = Number((noOfDaysSincePurchased / this.PerformanceDto[i].performanceCheckFrequency).toFixed(0))
            var Days = noOfTimesMaintenanceScheduled * this.PerformanceDto[i].performanceCheckFrequency
            var daysToMaintenance = 0;
            if (Days == noOfDaysSincePurchased) {
              daysToMaintenance = 0
            }
            else if (Days > noOfDaysSincePurchased) {
              daysToMaintenance = Days - noOfDaysSincePurchased
            }
            else {
              daysToMaintenance = noOfDaysSincePurchased - Days
            }

            if (daysToMaintenance == 0)
              this.maintenanceOnToday++;
            else if (daysToMaintenance <= 5)
              this.maintenanceinNext5Days++;
          }
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTriggers", error);
      });
    this.notificationSubscription = this.commonService.getAssetMaintenanceIssueStatus(JSON.parse(this.persistenceService.get('userDetail')).location.refNo).subscribe((data: any) => {
      if (data == null)
        return;
      this.AssetMaintenanceIssuesStatus = data?.length;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTriggers", error);
      });
    this.notificationSubscription = this.commonService.getInsuranceRenewalStatus(JSON.parse(this.persistenceService.get('userDetail')).location.refNo).subscribe((data: any) => {
      if (data == null)
        return;
      for (let i = 0; i < data?.length; i++) {
        if (data[i].period == "60")
          this.InsuranceStatusperiod60++;
        else if (data[i].period == "60")
          this.InsuranceStatusperiod60++;
        else if (data[i].period == "15")
          this.InsuranceStatusperiod15++;
        else if (data[i].period == "0")
          this.InsuranceStatusperiod0++;
        else if (data[i].period == "Lapsed")
          this.InsuranceStatusperiodlapses++;
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getTriggers", error);
      });
    this.getActivityLogs();

  }
  getActivityLogs() {
    this.activitySubscription = this.commonService.getActivityLog(JSON.parse(this.persistenceService.get('userDetail')).location.refNo, 50).subscribe((data: any) => {
      if (data == null)
        return;
      this.activityDTO = data;
      this.activityDTO.forEach(ef => {
        ef.transactionNo = ef.transactionNo.toString().trim();
      })
      this.getNotifications();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getActivityLogs", error);
      });
  }
  getNotifications() {
    this.notificationSubscription = this.commonService.getMessages(JSON.parse(this.persistenceService.get('userDetail')).location.refNo, "Web", 10).subscribe((data: any) => {
      if (data == null)
        return;
      this.messagesDTO = data;
      this.getOrderStatus();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getNotifications", error);
      });
  }

  getOrderStatus() {
    this.activitySubscription = this.commonService.getOrderStatus(JSON.parse(this.persistenceService.get('userDetail')).location.refNo).subscribe((data: any) => {
      if (data != null)
        this.orderStatus = data;
      if (this.orderStatus == null)
        return;
      this.availableCredit = this.orderStatus.availableCredit;
      this.lastOrderedValue = this.orderStatus.lastOrderedValue
      this.lastMonthOrderedValue = this.orderStatus.lastMonthOrderedValue
      this.lastPreviousMonthOrderedValue = this.orderStatus.lastPreviousMonthOrderedValue
      this.todayOrderValue = this.orderStatus.todayOrderValue
      this.lastReceivedValue = this.orderStatus.lastReceivedValue
      this.lastMonthReceivedValue = this.orderStatus.lastMonthReceivedValue
      this.lastPreviousMonthReceivedValue = this.orderStatus.lastPreviousMonthReceivedValue
      this.todayReceivedValue = this.orderStatus.todayReceivedValue
      this.lastReturnedValue = this.orderStatus.lastReturnedValue
      this.lastMonthReturnedValue = this.orderStatus.lastMonthReturnedValue
      this.lastPreviousMonthReturnedValue = this.orderStatus.lastPreviousMonthReturnedValue
      this.todayReturnedValue = this.orderStatus.todayReturnedValue;
      this.lastBilledValue = this.orderStatus.lastBilledValue
      this.lastMonthBilledValue = this.orderStatus.lastMonthBilledValue
      this.lastPreviousMonthBilledValue = this.orderStatus.lastPreviousMonthBilledValue
      this.todayBilledValue = this.orderStatus.todayBilledValue;
      this.lastPaymentValue = this.orderStatus.lastPaymentValue
      this.lastMonthPaymentValue = this.orderStatus.lastMonthPaymentValue
      this.lastPreviousMonthPaymentValue = this.orderStatus.lastPreviousMonthPaymentValue
      this.todayPaymentValue = this.orderStatus.todayPaymentValue;

      // Build chart data dynamically
      const memoryColumns = ["Date", "Ordered", "Received", "Payment"];
      const memoryData = [];

      for (let i = 0; i < data.orderedValues?.length; i++) {
        const today = new Date();
        const priorDate = new Date(new Date().setDate(today.getDate() - (30 - i)));
        const dt = `${priorDate.getMonth() + 1}-${priorDate.getDate()}-${priorDate.getFullYear()}`;
        memoryData.push([
          dt,
          data.orderedValues[i].amount,
          data.receivedValues[i].amount,
          data.paymentValues[i].amount
        ]);
      }
      this.orderChartData = {
        type: 'LineChart',
        columnNames: memoryColumns,
        data: memoryData,
        options: this.buildOrderChartOptions(),
        width: '100%',
        height: 290
      };
      this.showOrderGraph = memoryData.length > 0;
      // this.getSaleStatus();
      this.getSaleStatus1();

      // Apply theme dynamically — without recalling API
      this.themeSub?.unsubscribe();
      this.themeSub = this.themeService.isDarkTheme$.subscribe(isDark => {
        if (this.orderChartData) {
          this.orderChartData = {
            ...this.orderChartData,
            options: this.chartThemeService.applyTheme(this.buildOrderChartOptions(), isDark)
          };
        }
      });
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getOrderStatus", error);
      });
  }

  private buildOrderChartOptions() {
    return this.chartThemeService.applyTheme({
      hAxis: {
        title: 'Date'
      },
      legend: { position: 'none' },
      chartArea: { width: this.fullwidth, height: '80%', left: 40, top: 20, bottom: 60, right: 20 }
    });
  }

  getMakeToOrderStatus() {
    this.activitySubscription = this.commonService.getMakeToOrderStatus(
      JSON.parse(this.persistenceService.get('userDetail')).location.refNo
    ).subscribe((data: any) => {
      if (!data) return;

      this.mtoStatus = data;

      const todayData: any[] = [];
      const monthData: any[] = [];

      for (let i = 0; i < this.mtoStatus.length; i++) {
        const item = this.mtoStatus[i];
        const row = [item.process, item.qty];

        switch (item.process) {
          case 'Ordered': this.orderedQty = item.qty; break;
          case 'Production': this.productionQty = item.qty; break;
          case 'Dispatched': this.dispathcQty = item.qty; break;
          case 'Received': this.receiveQty = item.qty; break;
        }

        if (item.onDate === 'Today') todayData.push(row);
        else monthData.push(row);
      }

      // === TODAY CHART ===
      this.makeToOrderDataToday = {
        type: 'BarChart',
        columnNames: ["MTO", "Qty"],
        data: todayData,
        options: this.buildMTOChartOptions('Today'),
        width: '100%',
        height: 250
      };

      // === MONTH CHART ===
      this.makeToOrderDataMonth = {
        type: 'BarChart',
        columnNames: ["MTO", "Qty"],
        data: monthData,
        options: this.buildMTOChartOptions('Current Month'),
        width: '100%',
        height: 250
      };

      this.showMTOGraph = todayData.length > 0 || monthData.length > 0;

      // Dynamic theme update for both charts
      this.themeSubMTO?.unsubscribe();
      this.themeSubMTO = this.themeService.isDarkTheme$.subscribe(isDark => {
        if (this.makeToOrderDataToday) {
          this.makeToOrderDataToday = {
            ...this.makeToOrderDataToday,
            options: this.chartThemeService.applyTheme(this.buildMTOChartOptions('Today'), isDark)
          };
        }
        if (this.makeToOrderDataMonth) {
          this.makeToOrderDataMonth = {
            ...this.makeToOrderDataMonth,
            options: this.chartThemeService.applyTheme(this.buildMTOChartOptions('Current Month'), isDark)
          };
        }
      });

      this.getdashboardTopDivData();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getMakeToOrderStatus", error);
      });
  }

  private buildMTOChartOptions(title: string) {
    return this.chartThemeService.applyTheme({
      vAxis: {
        title: title,
        minValue: 0
      },
      hAxis: {
        minValue: 0
      },
      legend: { position: 'none' },
      chartArea: {
        top: 10, left: 50, right: 20, height: '80%', width: this.fullwidth
      }
    });
  }

  getSaleStatus1() {
    const date = new Date();
    const curentDayNo = date.getDate();
    const userRefNo = JSON.parse(this.persistenceService.get('userDetail')).location.refNo;

    this.activitySubscription = this.commonService.getSaleStatus(userRefNo).subscribe(
      (data: any) => {
        if (!data) return;

        this.saleStatusDto = data;
        this.showSaleGraph = data.length > 0;

        const billData: any[] = [];
        const amountData: any[] = [];

        // Running from today → first day of the month
        for (let d = curentDayNo; d >= 1; d--) {
          const transDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), d), 'yyyy-MM-dd');
          let qty = 0;
          let amt = 0;

          for (let i = 0; i < this.saleStatusDto.length; i++) {
            if (this.saleStatusDto[i].invoiceDate === transDate) {
              qty += this.saleStatusDto[i].qty;
              amt += this.saleStatusDto[i].totalAmount;
            }
          }

          billData.push([transDate, qty]);
          amountData.push([transDate, amt]);
        }

        // === BUILD BILLS CHART ===
        this.saleDataMonthBills = {
          type: 'ColumnChart',
          columnNames: ["On Date", "Bills"],
          data: billData,
          options: this.buildSaleChartOptions('Current Month Bills'),
          width: '100%',
          height: 250
        };

        // === BUILD AMOUNT CHART ===
        this.saleDataMonthAmount = {
          type: 'LineChart',
          columnNames: ["On Date", "Amount"],
          data: amountData,
          options: this.buildSaleChartOptions('Current Month Amount'),
          width: '100%',
          height: 250
        };

        // === THEME REACTIVITY ===
        this.themeSubSale?.unsubscribe();
        this.themeSubSale = this.themeService.isDarkTheme$.subscribe(isDark => {
          if (this.saleDataMonthBills) {
            this.saleDataMonthBills = {
              ...this.saleDataMonthBills,
              options: this.chartThemeService.applyTheme(this.buildSaleChartOptions('Current Month Bills'), isDark)
            };
          }
          if (this.saleDataMonthAmount) {
            this.saleDataMonthAmount = {
              ...this.saleDataMonthAmount,
              options: this.chartThemeService.applyTheme(this.buildSaleChartOptions('Current Month Amount'), isDark)
            };
          }
        });

        // Continue dashboard logic
        this.getMakeToOrderStatus();
      },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getSaleStatus1", error);
      }
    );
  }

  buildSaleChartOptions(vAxisTitle: string): any {
    return {
      legend: { position: 'none' },
      vAxis: {
        title: vAxisTitle,
      },
      hAxis: {
        title: 'Date',
        slantedText: true,
        slantedTextAngle: 45
      },
      chartArea: {
        top: 20,
        left: 20,
        right: 20,
        height: '80%',
        width: this.fullwidth,
      }
    };
  }


  dashboardToDivData: DashboardDto = new DashboardDto();
  getdashboardTopDivData() {
    this.activitySubscription = this.commonService.getDashboardTopDivData(JSON.parse(this.persistenceService.get('userDetail')).location.refNo).subscribe((data: any) => {
      if (data == null)
        return;
      this.dashboardToDivData = data;
    })
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Dashboard";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = this.persistenceService.get('OS');
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    });
  }

  // showLeftArrow = false;
  // showRightArrow = true;

  // @ViewChild('scrollDiv', { static: false }) scrollDiv!: ElementRef;

  // ngAfterViewInit() {
  //   this.onScroll(); // Initialize arrow visibility on load
  // }

  // onScroll() {
  //   const scrollElement = this.scrollDiv.nativeElement;
  //   this.showLeftArrow = scrollElement.scrollLeft > 0;
  //   this.showRightArrow = scrollElement.scrollLeft < scrollElement.scrollWidth - scrollElement.clientWidth;
  // }

  // scrollLeft() {
  //   this.scrollDiv.nativeElement.scrollBy({ left: -200, behavior: 'smooth' });
  // }

  // scrollRight() {
  //   this.scrollDiv.nativeElement.scrollBy({ left: 200, behavior: 'smooth' });
  // }



}
